import Heading from '../Typography/Heading';
import Paragraph from '../Typography/Paragraph';

const Error = () => {
  return (
    <div className="w-full h-full bg-white flex items-center justify-center flex-col">
      <Heading
        level="h2"
        style="text-red"
        text="Uh oh. Something went wrong."
      />
      <Paragraph text="Please try refreshing the page or check back later." />
    </div>
  );
};

export default Error;
